<template>
  <div>
    <v-card>
      <v-toolbar
        light
        color="white"
        class="elevation-2"
      >
        <v-toolbar-title>
          FAQ
        </v-toolbar-title>
      </v-toolbar>
      <div v-if="!this.busy && this.faqItems.length > 0">
        <v-expansion-panel>
          <v-expansion-panel-content
            v-for="(item, i) in faqItems"
            :key="i"
          >
            <div slot="header" class="primary--text font-weight-medium">{{item.question}}</div>
            <v-card class="px-2">
              <v-card-text v-html="item.answer">
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>
      <div class="py-4" v-if="busy">
        <div class="text-xs-center py-4">
          <v-progress-circular
            :size="24"
            :width="3"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import getList from './../../repository/faq/index';

export default {
  name: 'faq-list',
  data: () => ({
    busy: false,
    faqItems: [],
  }),
  methods: {
    async getFaqList() {
      this.busy = true;
      try {
        const faqResponse = await getList();
        this.faqItems = faqResponse.data.data.items;
        this.busy = false;
      } catch (e) {
        if (e) this.busy = false;
      }
    },
  },
  mounted() {
    this.getFaqList();
  },
};
</script>
